module.exports = __webpack_public_path__ + "static/media/hostSelected.3d74bb8e.svg";